import { Link } from 'react-router-dom';
import { ShoppingBag, Leaf, User, QrCode, SealCheck, Planet, Trophy } from '@phosphor-icons/react';
import { useCart } from '@/context/CartContext';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';

export const Navbar = () => {
  const { cartCount } = useCart();
  const hasIrisId = localStorage.getItem('ginsgood_iris_id');

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="https://tudugu.com/" className="flex items-center gap-2" data-testid="logo">
            <Leaf weight="duotone" className="w-8 h-8 text-primary" />
            <span className="font-semibold text-xl tracking-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              TDG Trace
            </span>
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="nav-link text-sm font-medium text-foreground/80 hover:text-foreground transition-colors" data-testid="nav-products">
              Home
            </Link>
            {/*<Link to="/artisans" className="nav-link text-sm font-medium text-foreground/80 hover:text-foreground transition-colors" data-testid="nav-artisans">
              Artisans
            </Link>*/}
            <Link to="/impact" className="nav-link text-sm font-medium text-foreground/80 hover:text-foreground transition-colors" data-testid="nav-impact">
              Impact
            </Link>
            <Link to="/carbon" className="nav-link text-sm font-medium text-foreground/80 hover:text-foreground transition-colors flex items-center gap-1" data-testid="nav-carbon">
              <Planet weight="duotone" className="w-4 h-4 text-green-600" />
              Carbon
            </Link>
            <Link to="/achievements" className="nav-link text-sm font-medium text-foreground/80 hover:text-foreground transition-colors flex items-center gap-1" data-testid="nav-achievements">
              <Trophy weight="duotone" className="w-4 h-4 text-yellow-500" />
              Rewards
            </Link>
            <Link to="/scan" className="flex items-center gap-2 cursor-pointer">
                    <QrCode weight="duotone" className="w-4 h-4" />
              Scan & Verify
            </Link>
            
            {/* Certification Dropdown */}
            {/*<DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="gap-2 text-sm font-medium text-foreground/80 hover:text-foreground" data-testid="nav-certify-dropdown">
                  <SealCheck weight="duotone" className="w-4 h-4" />
                  Certify
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                <DropdownMenuItem asChild>
                  <Link to="/scan" className="flex items-center gap-2 cursor-pointer">
                    <QrCode weight="duotone" className="w-4 h-4" />
                    Scan & Verify
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem asChild>
                  <Link to="/iris-auth" className="flex items-center gap-2 cursor-pointer">
                    <User weight="duotone" className="w-4 h-4" />
                    {hasIrisId ? 'My Identity' : 'Register Identity'}
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <Link to="/certify" className="flex items-center gap-2 cursor-pointer">
                    <SealCheck weight="duotone" className="w-4 h-4" />
                    Certify Product
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>*/}
          </div>

          {/* Right Side */}
          
          <div className="flex items-center gap-4">
            {/*<Link to="/iris-auth" className="flex items-center gap-2 cursor-pointer">
                    <User weight="duotone" className="w-4 h-4" />
                    {hasIrisId ? 'My Identity' : 'Register Identity'}
                  </Link>*/}
            <Link to="/scan" className="p-2 hover:bg-secondary rounded-full transition-colors md:hidden" data-testid="nav-scan-mobile">
              <QrCode weight="duotone" className="w-5 h-5 text-foreground/70" />
            </Link>
            {hasIrisId ? (
              <Link to="/profile" className="p-2 hover:bg-secondary rounded-full transition-colors" data-testid="nav-profile">
                <User weight="fill" className="w-5 h-5 text-primary" />
              </Link>
            ) : (
              <Link to="/iris-auth" className="p-2 hover:bg-secondary rounded-full transition-colors" data-testid="nav-admin">
                <User weight="duotone" className="w-5 h-5 text-foreground/70" />
              </Link>
            )}
            {/*<Link to="/cart" className="relative p-2 hover:bg-secondary rounded-full transition-colors" data-testid="nav-cart">
              <ShoppingBag weight="duotone" className="w-5 h-5 text-foreground/70" />
              {cartCount > 0 && (
                <Badge className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 text-xs bg-accent text-accent-foreground">
                  {cartCount}
                </Badge>
              )}
            </Link>*/}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
